import { render, staticRenderFns } from "./JewelryNicheIcon.vue?vue&type=template&id=429dfc7a&scoped=true"
import script from "./JewelryNicheIcon.vue?vue&type=script&lang=js"
export * from "./JewelryNicheIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "429dfc7a",
  null
  
)

export default component.exports